import React from 'react';
export default function PufferfishHatSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Spikes radiating outward */}
      <polygon points="20,1 18,8 22,8" fill="#8D6E3F" />
      <polygon points="20,39 18,32 22,32" fill="#8D6E3F" />
      <polygon points="1,20 8,18 8,22" fill="#8D6E3F" />
      <polygon points="39,20 32,18 32,22" fill="#8D6E3F" />
      <polygon points="6,6 10,11 12,9" fill="#8D6E3F" />
      <polygon points="34,6 30,11 28,9" fill="#8D6E3F" />
      <polygon points="6,34 10,29 12,31" fill="#8D6E3F" />
      <polygon points="34,34 30,29 28,31" fill="#8D6E3F" />

      {/* Additional smaller spikes */}
      <polygon points="12,3 12,9 14,7" fill="#A0805A" />
      <polygon points="28,3 28,9 26,7" fill="#A0805A" />
      <polygon points="3,12 9,12 7,14" fill="#A0805A" />
      <polygon points="37,12 31,12 33,14" fill="#A0805A" />

      {/* Main inflated body */}
      <circle cx="20" cy="20" r="12" fill="#FFD54F" />
      {/* Belly lighter area */}
      <ellipse cx="20" cy="22" rx="9" ry="8" fill="#FFECB3" />

      {/* Brown speckles on top */}
      <circle cx="16" cy="14" r="1" fill="#A1887F" opacity="0.6" />
      <circle cx="24" cy="12" r="0.8" fill="#A1887F" opacity="0.6" />
      <circle cx="20" cy="10" r="0.7" fill="#A1887F" opacity="0.5" />
      <circle cx="13" cy="18" r="0.6" fill="#A1887F" opacity="0.4" />
      <circle cx="27" cy="17" r="0.7" fill="#A1887F" opacity="0.5" />

      {/* Eyes - big and surprised */}
      <circle cx="15" cy="18" r="3" fill="white" />
      <circle cx="25" cy="18" r="3" fill="white" />
      <circle cx="16" cy="18" r="1.8" fill="#3E2723" />
      <circle cx="26" cy="18" r="1.8" fill="#3E2723" />
      <circle cx="15.5" cy="17" r="0.7" fill="white" />
      <circle cx="25.5" cy="17" r="0.7" fill="white" />

      {/* Mouth - small 'o' shape */}
      <ellipse cx="20" cy="24" rx="2" ry="1.5" fill="#E65100" />
      <ellipse cx="20" cy="23.5" rx="1.2" ry="0.8" fill="#BF360C" />

      {/* Tiny fins */}
      <ellipse cx="9" cy="22" rx="2" ry="1.5" fill="#FFC107" transform="rotate(-20 9 22)" />
      <ellipse cx="31" cy="22" rx="2" ry="1.5" fill="#FFC107" transform="rotate(20 31 22)" />
    </svg>
  );
}
